// src/components/AdminLayout.js
import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './AdminLayout.css'; // Criaremos este CSS a seguir
import logo from '../assets/logo.png';

const ChevronIcon = ({ isOpen }) => (
    <svg className={`chevron-icon ${isOpen ? 'open' : ''}`} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
);

const AdminLayout = () => {
    const { logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    // Lógica para manter os menus abertos se a rota atual for uma de suas filhas
    const isCatalogoPathActive = location.pathname.startsWith('/admin/catalogo');
    const [isCatalogoMenuOpen, setCatalogoMenuOpen] = useState(isCatalogoPathActive);
    
    const handleLogout = async () => {
        try {
            await logout();
            navigate('/');
        } catch (error) {
            console.error("Falha ao fazer logout", error);
        }
    };

    return (
        <div className="admin-layout">
            <aside className="admin-sidebar">
                <div className="sidebar-header" onClick={() => navigate('/admin/dashboard')}>
                    <img src={logo} alt="Logo" className="sidebar-logo" />
                    <h2>Painel Admin</h2>
                </div>
                <nav className="admin-nav">
                    <ul>
                        <li><NavLink to="/admin/dashboard">Dashboard</NavLink></li>
                        
                        {/* --- INÍCIO: NOVO MENU CATÁLOGO --- */}
                        <li className="nav-item">
                            <div className={`nav-item-toggle ${isCatalogoPathActive ? 'active-parent' : ''}`} onClick={() => setCatalogoMenuOpen(!isCatalogoMenuOpen)}>
                                <span>Catálogo</span>
                                <ChevronIcon isOpen={isCatalogoMenuOpen} />
                            </div>
                            {isCatalogoMenuOpen && (
                             <ul className="submenu">
    <li><NavLink to="/admin/catalogo/intelbras-produtos">Produtos Intelbras</NavLink></li>
    <li><NavLink to="/admin/catalogo/novotechnik-produtos">Produtos Novotechnik</NavLink></li>
    <li><NavLink to="/admin/catalogo/categorias">Categorias Novotechnik</NavLink></li>
    <li><NavLink to="/admin/catalogo/fabricantes">Fabricantes</NavLink></li>
    <li><NavLink to="/admin/catalogo/importador">Importador</NavLink></li>
</ul>
                            )}
                        </li>
                        {/* --- FIM: NOVO MENU CATÁLOGO --- */}
                    </ul>
                </nav>
                <div className="sidebar-footer">
                    <button onClick={handleLogout} className="logout-button">Sair</button>
                </div>
            </aside>
            <main className="admin-content">
                <Outlet /> {/* As páginas (Dashboard, Produtos, etc.) serão renderizadas aqui */}
            </main>
        </div>
    );
};

export default AdminLayout;